var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _vm.form.status == 'published' && _vm.isInValidTimeRange && _vm.deepGet(_vm.form, 'config.welcome_page.enable', false) ? [_vm.deepGet(_vm.form, 'config.welcome_page.banner_image') ? _c('img', {
    staticClass: "banner-image w-100",
    attrs: {
      "src": _vm.deepGet(_vm.form, 'config.welcome_page.banner_image')
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_vm.deepGet(_vm.form, 'config.welcome_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.welcome_page.form_title')) + " ")]) : _vm._e(), _vm.deepGet(_vm.form, 'config.welcome_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.welcome_page.form_desc')) + " ")]) : _vm._e(), _vm.deepGet(_vm.form, 'config.welcome_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.form, 'config.welcome_page.content'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": _vm.doesReachLimit
    },
    on: {
      "click": _vm.goToContent
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.welcome_page.button_text')) + " ")])], 1)])] : _vm.form.status == 'draft' || _vm.form.status == 'closed' ? [_vm._m(0), _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": "回 LINE 官方帳號",
      "button-url": "",
      "type": "OA"
    }
  })] : false == _vm.hasStarted ? [_vm._m(1), _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": "回 LINE 官方帳號",
      "button-url": "",
      "type": "OA"
    }
  })] : _vm.hasEnded ? [_vm._m(2), _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": "回 LINE 官方帳號",
      "button-url": "",
      "type": "OA"
    }
  })] : _vm._e()], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v("找不到此活動")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v("此活動尚未開始")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v("此活動已結束")])]);
}]

export { render, staticRenderFns }